import React from "react"
import Stack from "@mui/material/Stack"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { getStaticAssetUrl } from "appRedux/baseQuery"
import LazyImage from "components/atoms/LazyImage"

type ItemCardProps = {
  name: string;
  image: string | File | null;
  children?: React.ReactNode;
  onItemClick: () => void;
}

export default function ItemCard(props: ItemCardProps) {
  const { name, image, children = null, onItemClick } = props

  return (
    <Stack flexDirection="row" gap="8px">
      <ImageContainer onClick={onItemClick}>
        <LazyImage
          src={typeof image === "string" ? getStaticAssetUrl(image) : null}
          alt={name}
        />
      </ImageContainer>
      <Stack gap="4px" width="100%">
        <ItemName onClick={onItemClick}>{name}</ItemName>
        {children}
      </Stack>
    </Stack>
  )
}

const ImageContainer = styled(Stack)(({ theme }) => ({
  width: "68px",
  height: "68px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.gray["8"]}`,
  backgroundColor: theme?.palette.gray["4"],
  position: "relative",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  overflow: "hidden",
  backgroundSize: "cover"
}))

const ItemName = styled(Typography)(({ theme }) => ({
  width: "fit-content",
  fontSize: "1.2rem",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))
